import TextStylePicker from './TextStylePicker';

export default TextStylePicker;